<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addAdminModal"
              @click="generatePassword(8)"
            >
              <i class="fas fa-plus ms-1"></i>
              إضافة مشرف جديد
            </button>

            <!-- Add Modal Start -->
            <div
              class="modal fade"
              id="addAdminModal"
              tabindex="-1"
              aria-labelledby="addAdminModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة مشرف</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="this.clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form
                      id="addAdminForm"
                      @submit.prevent="addNewAdmin($event)"
                    >
                      <div class="row">
                        <!-- admin Name -->
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label for="adminName">الاسم الاول</label>
                            <input
                              type="text"
                              id="adminName"
                              class="form-control"
                              placeholder="الاسم"
                              v-model="admin.firstName"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label for="adminName">الاسم الاخير</label>
                            <input
                              type="text"
                              id="adminName"
                              class="form-control"
                              placeholder="الاسم"
                              v-model="admin.lastName"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label for="adminEmail"> البريد الالكتروني</label>
                            <input
                              type="email"
                              id="adminEmail"
                              class="form-control"
                              placeholder="example@example.com"
                              v-model="admin.email"
                              required
                            />
                          </div>
                        </div>

                        <!-- admin Password -->
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label for="adminPassword">كلمة المرور</label>
                            <input
                              type="text"
                              id="adminPassword"
                              class="form-control"
                              placeholder="كلمة المرور"
                              v-model="admin.password"
                              required
                              maxlength="8"
                            />
                          </div>
                        </div>
                        <p class="text-muted text-sm col-12">الصلاحيات</p>
                        <div class="col-12">
                          <div class="row">
                            <div
                              class="col-sm-6"
                              v-for="(permission, index) in permissions"
                              :key="index"
                            >
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  :id="`add-permission-${permission.key}`"
                                  :value="permission.key"
                                  v-model="admin.permissions"
                                />
                                <label
                                  class="form-check-label"
                                  :for="`add-permission-${permission.key}`"
                                >
                                  {{ permission.title }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Buttons -->
                        <div class="col-12">
                          <div class="form-group text-start mt-4">
                            <button type="submit" class="btn add w-100">
                              أضافة
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Modal End -->
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <Transition name="scale" mode="out-in">
            <div class="table__select" v-if="this.checkedAdmins.length > 0">
              <div class="table__select__count">
                تم تحديد {{ this.checkedAdmins.length }}
              </div>
              <div class="table__select__buttons">
                <button class="btn delete" @click="deleteAdminsList()">
                  <i class="fas fa-trash-alt ms-2"></i>
                  حذف
                </button>
              </div>
            </div>
          </Transition>
          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh($event)"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <table v-show="this.admins.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th class="text-center" style="width: 5%" scope="col">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="allSelected"
                      @change="selectAll"
                    />
                  </th>
                  <th style="width: 5%" scope="col">الرقم</th>
                  <th scope="col">اسم مشرف</th>
                  <th scope="col">البريد الالكتروني</th>
                  <th class="controls" scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(admin, index) in this.admins" :key="index">
                  <th class="text-center" scope="row">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="flexCheckDefault"
                      v-model="checkedAdmins"
                      @change="updateCheckall()"
                      :value="admin"
                    />
                  </th>
                  <th class="text-center" scope="row">{{ index + 1 }}</th>
                  <td>
                    {{ [admin.firstName, admin.lastName].join(" ") }}
                  </td>
                  <td>{{ admin.email }}</td>

                  <td>
                    <div class="controls cate">
                      <button
                        class="btn edit"
                        data-bs-toggle="modal"
                        data-bs-target="#EditadminModal"
                        @click="this.getSelectAdmin(admin)"
                      >
                        <i class="fas fa-user-cog ms-1"></i>
                        تعديل الصلاحيات
                      </button>
                      <button
                        class="btn delete"
                        @click="deleteSelectedadmin(admin)"
                      >
                        <i class="fas fa-trash-alt ms-1"></i>
                        حذف
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- Edit permissions modal: ONE instance, outside the row
                 v-for. It used to be rendered per row with the same id,
                 so the trigger always opened the first row's copy. -->
            <div
              class="modal fade"
              tabindex="-1"
              id="EditadminModal"
              aria-labelledby="EditadminModalLabel"
              data-bs-backdrop="static"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">بيانات المشرف</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="updateAdminClose"
                    ></button>
                  </div>
                  <form @submit.prevent="updateSelectAdmin">
                    <div class="modal-body text-end row px-4">
                      <div
                        class="alert alert-secondary col-12"
                        role="alert"
                      >
                        ليتم تعديل البيانات الشخصية يجب تسجيل الدخول
                        من خلال البيانات الاساسية لتلك المشرف مثل
                        البريد الالكتروني و كلمة المرور, لا يمكنك
                        التعديل من هنا . شكرا لك
                      </div>

                      <p class="text-muted text-sm">الصلاحيات</p>
                      <div>
                        <div class="row">
                          <div
                            class="col-sm-6"
                            v-for="(permission, index) in permissions"
                            :key="index"
                          >
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :id="`edit-permission-${permission.key}`"
                                :value="permission.key"
                                v-model="editedPermissions"
                              />
                              <label
                                class="form-check-label"
                                :for="`edit-permission-${permission.key}`"
                              >
                                {{ permission.title }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button class="btn w-100 edit" type="submit">
                        تعديل
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <nav
              class="pagination"
              v-show="this.isShowButton"
              aria-label="Page navigation"
            >
              <button
                class="btn add"
                @click="this.getNextSelectedData"
                v-if="!this.loadingMore"
              >
                تحميل المزيد
              </button>
              <div v-else>
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </nav>
            <div
              v-show="
                (!this.isloading && !this.admins) || this.admins.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد مشرفين حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";

// Canonical permission list — shared with the router metas and the sidebar.
import { PERMISSIONS, sanitizePermissions } from "@/constants/permissions";

export default {
  data() {
    return {
      // Loading
      isloading: false,
      // Get Categories has Main
      grades: [],
      // All Classes
      classes: [],
      // Current Page Name
      currentView: "الطلاب",
      admins: [],
      // update admin
      updateAdminObj: {},
      // Document id of the admin currently open in the edit modal.
      editingUid: null,
      // Print admin
      adminPrint: {
        name: "",
        password: "",
        phone: "",
        grade: {
          title: "",
        },
        classes: [],
      },
      // admin Data
      admin: {
        permissions: [],
      },
      classesBefore: [],
      adminBeforeEdit: {},
      // Select
      allSelected: false,
      checkedAdmins: [],
      // Pagination
      loadingMore: false,
      isShowButton: true,

      // Search
      searchResult: [],
      // Canonical, assignable permission list.
      permissions: PERMISSIONS,
      // Local copy of the permissions being edited, so the checkboxes cannot
      // mutate Vuex state directly.
      editedPermissions: [],
    };
  },

  methods: {
    ...mapActions("adminsModule", [
      // "fetchAdmins",
      "addAdmin",
      "getAdminById",
      "updateAdmin",
      "updateAdminPermissions",
      "deleteAdmin",
      "deleteAdmins",
      "addClassesToAdmins",
      // Pagination
      "getFirstData",
      "getNextData",
      "changeSorting",

      // Search
      "searchData",
    ]),

    //

    //
    // Pagination
    getNextSelectedData() {
      this.getNextData();
    },
    getPrevSelectedData() {
      this.getPrevData();
    },

    //--------------------------------------------
    // Sorting
    sortByCreateDate() {
      this.changeSorting("created_date");
      this.getFirstData();
    },
    sortByName() {
      this.changeSorting("name");
      this.getFirstData();
    },
    //-------------------------------------
    // Search
    getDocBySeacrh(e) {
      if (e.target.value == "") {
        this.admins = this.getAdmins;
      } else {
        setTimeout(() => {
          this.searchData(e.target.value);
          this.admins = this.searchResult;
        }, 800);
      }
    },
    //-------------------------------------

    // Grt All admins
    async getAlladmin() {
      if (this.isFirstLoad) this.admins = await this.fetchAdmins();
    },

    //-------------------------------------
    // Select
    async selectAll() {
      this.checkedAdmins = [];
      if (this.allSelected) {
        const selected = this.admins.map((admin) => admin);
        this.checkedAdmins.push(...selected);
      } else {
        this.selected = [];
        this.checkedAdmins = [];
      }
    },
    updateCheckall() {
      if (this.admins.length == this.checkedAdmins.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
    //---------------------------------------------------
    // Functions On Select admins
    async deleteAdminsList() {
      Swal.fire({
        text: "هل أنت متأكد من حذف هولاء الطلاب؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الاكواد بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteAdmins(this.checkedAdmins);
          this.removeAdminFromClass(this.checkedAdmins);
          this.decreaseCount(this.checkedAdmins.classes);
          this.checkedAdmins = [];
        }
      });
    },

    //-----------------------------------------------------
    // Default Buttons in Table
    // Add New admin
    async addNewAdmin(event) {
      // eslint-disable-next-line no-unused-vars
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      let adminCreated = await this.addAdmin(this.admin);
      if (!adminCreated) return;
      console.log(adminCreated);
      closeButton.click();

      this.clearAndShowSuccess("تم الإضافة بنجاح");
    },

    // Delete admin
    deleteSelectedadmin(admin) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا المشرف؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم الحذف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          //   this.removeAdminFromClass(admin);
          this.deleteAdmin(admin.uid);
          //   this.decreaseCount(admin.classes);
        }
      });
    },

    // Get admin By Id
    async getSelectAdmin(admin) {
      this.adminBeforeEdit = admin;
      // The document id is the admin id; `admin.uid` is only a mirrored field.
      this.editingUid = admin.uid;

      try {
        const stored = await this.getAdminById(admin.uid);
        this.updateAdminObj = { ...(stored ?? admin), uid: admin.uid };
      } catch (error) {
        console.error("Could not load the admin", error);
        this.updateAdminObj = { ...admin };
      }

      // Work on a copy — binding the checkboxes straight to Vuex state meant
      // the edit form mutated the store outside a mutation.
      this.editedPermissions = sanitizePermissions(
        this.updateAdminObj.permissions
      );
    },

    // Update admin permissions.
    // Awaits the write and only reports success if it actually succeeded: this
    // used to be fire-and-forget, so a denied write still showed
    // "تم التعديل بنجاح" while nothing changed.
    async updateSelectAdmin() {
      if (!this.editingUid) {
        this.showError("لم يتم تحديد المشرف");
        return;
      }

      try {
        await this.updateAdminPermissions({
          uid: this.editingUid,
          permissions: sanitizePermissions(this.editedPermissions),
        });
      } catch (error) {
        console.error("Could not update the permissions", error);
        this.showError("لم يتم تعديل الصلاحيات، تحقق من الصلاحيات ثم حاول مرة اخرى");
        return;
      }

      const closeButton = document.getElementById("updateAdminClose");
      if (closeButton) closeButton.click();
      this.clearAndShowSuccess("تم التعديل بنجاح");
    },

    showError(title) {
      Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      }).fire({ icon: "error", title });
    },

    // Code Download PDF
    onProgress(event) {
      console.log(`Processed: ${event} / 100`);
    },
    hasGenerated() {
      alert("PDF generated successfully!");
    },
    //-----------------------------------------------------
    // Get Classes Ids Only
    //-----On Add

    //-----------------------------------------------------
    // Clear Input and Messages me Success
    clearAndShowSuccess(message) {
      this.successAdd(message);
      this.clearData();
    },
    // Toast Seccuss Message
    successAdd(message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    // Clear Data
    clearData() {
      this.admin = {
        permissions: [],
      };
      this.updateAdminObj = {};
    },
    // Generate Random Password
    generatePassword(length) {
      const characters = "0123456789";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      this.admin.password = result;
    },
  },
  async created() {
    // if (this.isFirstLoad) await this.fetchAdmins();
    await this.getFirstData();

    // get Main Categories
    // this.grades = this.getCategories.filter(
    //   (item) => item.main_category === true && item.show_on_register === true
    // );
  },
  computed: {
    ...mapGetters("adminsModule", [
      "getAdmins",
      "getUpdateAdmin",
      "isLoading",
      "isFirstLoad",
      // Pagination
      "isLoadingMore",
      "isShowLoadingButton",
      // Search
      "getSearchResult",
    ]),
  },
  mounted() {
    this.admins = this.getAdmins;
    this.categories = this.getCategories;
    this.classes = this.getClasses;
    this.isloading = this.isLoading;
    this.firstLoad = this.isFirstLoad;
    // Pagination
    this.isShowButton = this.isShowLoadingButton;
    this.loadingMore = this.isLoadingMore;

    // Search
    this.searchResult = this.getSearchResult;
    // document.getElementById("adminGrade").value = 0;
  },
  watch: {
    getAdmins() {
      this.admins = this.getAdmins;
    },
    getCategories() {
      this.categories = this.getCategories;
    },
    getClasses() {
      this.classes = this.getClasses;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
    // Pagination
    isLoadingMore() {
      this.loadingMore = this.isLoadingMore;
    },
    isShowLoadingButton() {
      this.isShowButton = this.isShowLoadingButton;
    },
    // Search
    getSearchResult() {
      this.searchResult = this.getSearchResult;
    },
  },
};
</script>

<style></style>
